import BasicSprite from "./BasicSprite";
import Sprite from "./Sprite";
import Spritesheet from "./Spritesheet";

export default class AnimationRowSpritesheet extends Spritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     */
    constructor(fileName, spriteSize) {
        super(fileName, spriteSize)

        /**
         * @constant
         * @type {number}
         */
        this.step = this.calculateSpriteStep(spriteSize);
        ////this.step = this.spriteSize + 1;
    }

    /**
     * @abstract
     * @param {number} spriteSize
     * @returns {number}
     */
    calculateSpriteStep(spriteSize) {        
    }

    /**
     * @param {number} row 
     * @param {number} numSprites 
     * @returns {Array.<Sprite>}
     */
    parseRow(row, numSprites) {
        const sprites = [];

        let y = row * this.step;
        let x = 0;

        for (let col = 0; col < numSprites; col++) {
            sprites.push(new BasicSprite(this, x, y));
            x += this.step;
        }

        return sprites;
    }

}